import React from "react";
import { CoursePublishState } from "../../types/helperTypes";
import { PageTypography, PageTypographyLevel } from "../common/PageTitle";
import { CoursesContainer } from "../course/course-list/CoursesContainer";

interface IHomeSampleReviewedCoursesProps {}

export const HomeSampleReviewedCourses: React.FunctionComponent<
  IHomeSampleReviewedCoursesProps
> = (props) => {
  return (
    <>
      <PageTypography
        title={"Check out courses created by people just like you"}
        level={PageTypographyLevel.PageSection}
        style={{ marginBottom: "1rem" }}
      />
      <CoursesContainer
        listCoursesQueryParams={{
          publishStates: [CoursePublishState.Published],
          sortByUpdatedAt: true,
        }}
      />
    </>
  );
};
